import React from "react";
import { Link } from "react-router-dom";
import { CHAT_MODELS } from "../../services/ai/models";
import { IS_MOCK } from "../../services/config";
import { useTheme } from "../../context/ThemeContext";
import { IconButton, Logo, ModelMark, Icon } from "../../components/ui";

export default function AuthLayout({ title, subtitle, children, footer, variant }) {
  const { theme, toggle } = useTheme();
  const orbit = CHAT_MODELS.slice(4, 12);
  return (
    <div className={"auth" + (variant === "admin" ? " is-admin" : "")}>
      <div className="auth-art">
        <Link to="/" className="auth-logo"><Logo size={34} /></Link>
        <div className="auth-art-body">
          <div className="auth-orbit">
            <div className="auth-orbit-core"><Logo size={64} text={false} /></div>
            {orbit.map((m, i) => (
              <span key={m.id} className="auth-orbit-item" style={{ "--i": i, "--n": orbit.length }}>
                <ModelMark model={m} size={40} />
              </span>
            ))}
          </div>
          <h2>{variant === "admin" ? "ศูนย์ควบคุม MixAI" : "AI ทุกค่ายในที่เดียว"}</h2>
          <p>{variant === "admin" ? "จัดการผู้ใช้ ราคา แพ็กเกจ และโมเดลทั้งหมดของระบบ" : "แชท เขียน แปล สรุป และสร้างสรรค์ด้วยโมเดลชั้นนำ จ่ายครั้งเดียว ไม่ต้องสมัครหลายเจ้า"}</p>
          {variant !== "admin" ? (
            <div className="auth-quote">
              <div className="auth-stars">{[0, 1, 2, 3, 4].map((i) => <Icon key={i} name="star" size={14} />)}</div>
              “เปลี่ยนโมเดลได้ในแชทเดียว ประหยัดค่าสมัครหลายเจ้าไปเยอะมาก”
              <span>— ผู้ใช้ MixAI สาย Content Creator</span>
            </div>
          ) : null}
        </div>
      </div>
      <div className="auth-main">
        <div className="auth-top">
          <Link to="/" className="auth-logo-sm"><Logo size={28} /></Link>
          <IconButton icon={theme === "dark" ? "sun" : "moon"} label="สลับธีม" onClick={toggle} />
        </div>
        <div className="auth-card">
          <h1>{title}</h1>
          {subtitle ? <p className="muted">{subtitle}</p> : null}
          {children}
          {footer ? <div className="auth-footer">{footer}</div> : null}
          {IS_MOCK ? (
            <div className="auth-mock">
              <Icon name="info" size={14} /> โหมดทดลอง: สมัครด้วยอีเมลอะไรก็ได้ (อีเมลขึ้นต้นด้วย <b>admin</b> = super_user)
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
